import { all, put, take } from 'redux-saga/effects';
import { types as commonTypes } from '../../actions/backendCommon';
import { types } from '../../actions/backendMain';

/**
 * @deprecated Old Listener APP
 * @returns {Generator<*, void, *>}
 */
export function* waitForSettingsAndMainConnection() {
    yield all([take(types.DAEMON_VERSION_RECEIVED), take(commonTypes.ALL_SETTINGS_RECEIVED)]);

    yield put({
        type: types.REQUEST_LEGACY_LISTENER_DEVICE_LIST
    });
}

export default [waitForSettingsAndMainConnection()];
